<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Paxel Market - Join Procedure</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Join Procedure</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="title-id"
          >
            <input
              v-model="item.title.id"
              v-validate="'required'"
              name="title_id"
              data-vv-as="Title Bahasa"
              id="title-id"
              class="form-control"
              placeholder="Title in Bahasa"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{
              veeErrors.first("title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (English)"
            label-class="control-label"
            class="required"
            label-for="title-en"
          >
            <input
              v-model="item.title.en"
              v-validate="'required'"
              name="title_en"
              data-vv-as="Title English"
              id="title-en"
              class="form-control"
              placeholder="Title in English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{
              veeErrors.first("title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Description (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="description-id"
          >
            <input
              v-model="item.description.id"
              v-validate="'required'"
              name="description_id"
              data-vv-as="Description Bahasa"
              id="description-id"
              class="form-control"
              placeholder="Description in Bahasa"
            />
            <b-form-invalid-feedback id="input-description_id-feedback">{{
              veeErrors.first("description_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Description (English)"
            label-class="control-label"
            class="required"
            label-for="description-en"
          >
            <input
              v-model="item.description.en"
              v-validate="'required'"
              name="description_en"
              data-vv-as="Description English"
              id="description-en"
              class="form-control"
              placeholder="Description in English"
            />
            <b-form-invalid-feedback id="input-description_en-feedback">{{
              veeErrors.first("description_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Image (JPG/PNG):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.png/.jpg)</b>
                <sup class="text-secondary pl-3"
                  >(1 MB)&nbsp;(180px x 390px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileJpg"
                  name="imagejpg"
                  data-vv-as="Image JPG/PNG"
                  v-validate="
                    !item.image_jpg
                      ? 'required|minimalDimensions:180,390|ratiolDimensions:180,390|size:1000|ext:jpg,png'
                      : 'minimalDimensions:180,390|ratiolDimensions:180,390|size:1000|ext:jpg,png'
                  "
                  style="display: none"
                  v-on:change="onChangeFileJpg()"
                />
                <b-button
                  @click="$refs.fileJpg.click()"
                  v-show="!item.image && !fileJpg"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image || fileJpg"
                  variant="primary"
                  @click="modalJpg = !modalJpg"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileJpg.click()"
                  v-show="item.image || fileJpg"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagejpg") }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model="item.status"
              :options="optionsStatus"
              name="radio-status"
              v-validate="'required'"
              data-vv-as="Status"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-status') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'PaxelMarketJoinProcedure' }">
            <b-button :disabled="loading" class="col-2 mr-3" variant="outline-secondary" size="lg">Batal</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="col-2"
            size="lg"
          >
            Simpan
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalJpg" title="Preview Image" size="xl">
      <img
        v-show="!fileJpg"
        v-if="item.image"
        width
        height="400px"
        :src="item.image"
      />
      <img
        v-show="fileJpg"
        v-if="urlJpg"
        width
        height="400px"
        :src="urlJpg"
      />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {
        title: {
          id: "",
          en: ""
        },
        description: {
          id: "",
          en: ""
        },
        image: "",
        status: "",
      },
      optionsStatus: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" },
      ],
      loading: false,
      modalJpg: false,
      fileJpg: "",
      urlJpg: "",
    }
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("title_id", this.item.title.id);
          formData.append("title_en", this.item.title.en);
          formData.append("description_id", this.item.description.id);
          formData.append("description_en", this.item.description.en);
          formData.append("image", this.fileJpg);
          formData.append("status", this.item.status);
          this.$store
            .dispatch("PaxelMarketJoinProcedureModule/postJoinProcedure", formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: "PaxelMarketJoinProcedure" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data.message;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    onChangeFileJpg() {
      this.fileJpg = this.$refs.fileJpg.files[0];
      const input = this.$refs.fileJpg;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlJpg = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  }
};
</script>

<style>
</style>
